<div class="flex" *transloco="let transloco">
  <p-toggleswitch
    [ngClass]="{
      'ng-dirty ng-invalid p-invalid': this.showError
    }"
    [readonly]="this.props.readonly"
    [formControl]="this.formControl"
    [formlyAttributes]="this.field">
  </p-toggleswitch>
</div>
